<div class="profile_container">
    <ui-page-header [title]="'user.user' | translate" [lucideIcon]="'User'">
      <ui-button 
        type="primary"
        [label]="'common.save' | translate"
        icon="check_icon"
        (click)="save()"
      ></ui-button>
    </ui-page-header>
    <div class="content_plan" [formGroup]="form">
        <div class="form-content">
            <div class="form-content-title">{{ "user.user_details" | translate }}</div>
            <!-- User Name -->
            <div class="standard-input">
              <label for="name">{{
                "user.user_name" | translate
              }}</label>
              <input
                type="text"
                formControlName="name"
              />
            </div>

            <!-- User Email -->
            <div class="standard-input">
                <label for="email">{{
                  "common.email" | translate
                }}</label>
                <input
                  type="text"
                  formControlName="email"
                  readonly
                />
              </div>

              <!-- User Phone -->
              <div class="standard-input">
                <label for="phone">{{
                  "user.phone_number" | translate
                }}</label>
                <input
                  type="text"
                  formControlName="phone"
                />
              </div>

              <!-- User Image -->
              <div class="standard-input image-upload-container">
                <label for="image">{{
                  "user.avatar_photo" | translate
                }}</label>
                <div
                    class="dialog-content-upload-file"
                    role="button"
                    tabindex="0"
                    aria-label="Upload files"
                    (click)="fileInput.click()"
                    (keydown.enter)="fileInput.click()"
                    (keydown.space)="$event.preventDefault(); fileInput.click()"
                >
                    <div class="upload-file-label" *ngIf="!avatarPreviewUrl; else avatarPreview">
                      <ui-svg-icon svgIcon="upload-icon" size="medium"></ui-svg-icon>
                      <div class="upload-file-label-text">
                          <span>Upload File</span>
                      </div>
                    </div>
                    <ng-template #avatarPreview>
                      <div class="avatar-preview">
                        <img class="avatar-preview-img" [src]="avatarPreviewUrl" alt="Avatar preview" />
                        <ui-button type="transparent" class="avatar-remove-btn" icon="close" iconSize="large" (click)="clearAvatar(fileInput, $event)"></ui-button>
                      </div>
                    </ng-template>
                    <div class="upload-file-container">
                        <ui-button
                            [type]="'secondary'"
                            [label]="'Browse file'"
                            (click)="$event.stopPropagation(); fileInput.click()"
                        ></ui-button>
                        <input 
                            type="file" 
                            #fileInput
                            accept=".png,.jpg,.jpeg,.webp,.gif"
                            (change)="onAvatarFileChange($event)"
                            style="display: none;"
                        />
                    </div>
                </div>
              </div>
              
            <div class="form-content-title">{{ "user.preferences" | translate }}</div>
            
            <!-- language -->
            <div class="standard-input">
              <label for="language">{{ "settings.language" | translate }}</label>
              <mat-select name="language" id="language" formControlName="language" (selectionChange)="switchLanguage($event)">
                <mat-option value="en">{{ "language.english" | translate }}</mat-option>
                <mat-option value="it">{{ "language.italian" | translate }}</mat-option>
                <mat-option value="fr">{{ "language.french" | translate }}</mat-option>
              </mat-select>
            </div>   
            
            <div class="preference-card">
              <div class="preference-header">
                <div style="display: flex; flex-direction: column; gap: 8px">
                  <div class="preference-title">
                    {{
                      "user.receive_notifications" | translate
                    }}
                  </div>
                  <div class="preference-desc">
                    {{ "user.receive_notifications_desc" | translate }}
                  </div>
                </div>
                <mat-slide-toggle class="toggle-btn" formControlName="receive_emails"></mat-slide-toggle>
              </div>
            </div>

            <div class="preference-card" *ngIf="desktopToggleState !== 'unsupported'">
              <div class="preference-header">
                <div style="display: flex; flex-direction: column; gap: 8px">
                  <div class="preference-title">
                    {{ "user.desktop_notifications" | translate }}
                  </div>
                  <div class="preference-desc">
                    {{ "user.desktop_notifications_desc" | translate }}
                  </div>
                  <div class="preference-desc" *ngIf="desktopToggleState === 'blocked'">
                    {{ "user.desktop_notifications_blocked" | translate }}
                  </div>
                </div>
                <mat-slide-toggle
                  class="toggle-btn"
                  [checked]="desktopChecked"
                  [disabled]="desktopToggleState === 'blocked'"
                  (change)="onDesktopNotificationsToggle($event.checked)"
                ></mat-slide-toggle>
              </div>
            </div>
          </div>
    </div>
</div>